// extracted by mini-css-extract-plugin
export default {"switcher":"LanguageSwitcher_switcher__J55+n","language":"LanguageSwitcher_language__8uOfp"};